import React, { lazy, Suspense } from 'react';

const TemplatesContainer = lazy(() =>
  import(/* webpackChunkName: "templates-container" */ './TemplatesContainer'),
);

export const LazyTemplatesContainer: React.FunctionComponent<{
  category?: string;
  shortLink?: string;
}> = ({ category, shortLink }) => {
  return (
    <Suspense fallback={null}>
      <TemplatesContainer category={category} shortLink={shortLink} />
    </Suspense>
  );
};
